var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('Nav'),_vm._v(" "),_c('div',{staticClass:"d-flex flex-md-grow-1"},[_c('router-view',{attrs:{"name":"base"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }